import styles from "./scss/neweventpopup.module.scss";

import taskimg2 from "../../../styles/images/task2.svg";
import taskimg1 from "../../../styles/images/task1.svg";
import {  Input, Menu, Dropdown, Select, Form, DatePicker,Modal } from 'antd';
import { Radio } from 'antd';
import React, { useEffect, useState } from 'react';
// import { Progress, Menu, Dropdown, Select, Tooltip, DatePicker, Space } from "antd";
import IcloudImg from "../../../styles/images/event/icloud.svg";
import GoogleCalcImg from "../../../styles/images/event/google_calendar.svg";
import OutlookImg from "../../../styles/images/event/outlook.svg";
import ClickDropdown from "../../../shared/widgets/clickDropdown";
import { URButton } from "../../../shared/widgets/button";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, initialStateModel, LoginState } from "../../../models/model";
import moment from "moment";
import { chatSideWindow, RRuleGeneration, updateEventCreation,deleteEventCreation } from "../../../base/eventService/eventApiService";
import { RRule } from 'rrule';
import { getcontactDetail, SearchFilter } from "../../../base/utils";
import _ from "lodash";
import TextArea from "antd/lib/input/TextArea";
import { ChatService } from "../../../base/chatService";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { userStatusColor } from "../../../base/callService/common";
type eventState = {
  isRecurringEvent: boolean;
  recurrence: string;
  eventName: string;
  startDate: Date;
  time: any;
  hours: number;
  minutes: number;
  participants: any;
  calendarType: number;
  description: string;
  allDay: boolean;
  reminder: string;
  endDate: Date;
  taskId: string;
  location: string;
  rruleValue: string;
  rruleText: string;
  duration: Date;
  contacts: Array<any>;
  tempfilteredContacts: Array<any>;
  isAddParticipant: boolean;
  selectMember: Array<any>;
  isStartEventDate: boolean;
  isEndEventDate: boolean;
  durationRes:Date;
  assigneeError:boolean;
  isLocation: boolean;
  sender:any;
  receiver:any;
  endError:boolean;
  startTimeError:boolean;
  domainId:any;
}
export default function EditEventRightBar(props: any) {
  //const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let { chatWindowDetails } = chatWindow;
  let {  loginReducer } = allReducer;
   let { userdetails }: LoginState = loginReducer;
   const [isAssignee, setisAssignee] = useState(false);
   const [deleteevent, setdeleteEvent] = useState(false);
   let memberList = chatWindowDetails?.team_members?.split(",");
   memberList = Array.isArray(memberList) && memberList.length > 0 ?
         memberList.map((data: any, index: any) => data.trim()) : [];
  const contactList = allReducer.contactReducer.workContacts;
  var evens = _.map(contactList, function(n) {
    return n;
  });
  const [eventInfo, setEventInfo] = useState<eventState>
    ({
      isRecurringEvent: false, recurrence: "", eventName: "", startDate: new Date(),durationRes:new Date(), time: "", hours: 1, minutes: 0,
      participants: [], calendarType: 0, description: "", allDay: false, reminder: "", endDate: new Date(), taskId: "",
      location: "", rruleValue: "", rruleText: "", duration: new Date(), contacts: evens,assigneeError:false,isLocation:false,
      tempfilteredContacts: evens, isAddParticipant: false, selectMember: [], isStartEventDate: false, isEndEventDate:false,
      sender:"",receiver:"",endError:false,startTimeError:false,domainId:""});

  useEffect(() => {
    if (props.isEdit) {
      var start_date:any = new Date(parseFloat(props.isEdit.dtstart) * 1000);
      let editRRule: any = new RRule(RRule.parseString(props.isEdit.rrule));
      var end_date = new Date(parseFloat(props.isEdit.dtend) * 1000);
      var duration:any = new Date(parseFloat(props.isEdit.duration) * 1000);
      let participants: any = [];
      let selectMember: any = [];
      var diffMs = (duration - start_date);
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
      var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
      let checkAssignee: boolean = props.isEdit?.sender === userdetails?.sip_login_id;
      setisAssignee(checkAssignee);
      let timeRes = moment(new Date(start_date)).format('HH:mm')
      props.isEdit.inviteParticipants && props.isEdit.inviteParticipants.map((data: any) => {
        selectMember.push(getcontactDetail(data));
        participants.push(parseInt(data));
      });
      setEventInfo({
        ...eventInfo, isRecurringEvent: false, recurrence: props.isEdit.recurOptions,
        eventName: props.isEdit.summary,
        startDate: start_date,hours:diffHrs,
        time: timeRes, duration: props.isEdit.duration, minutes: diffMins, durationRes:duration,
        reminder: props.isEdit.reminder,
        endDate: end_date,
        participants: participants, calendarType: props.isEdit.calender,
        taskId: props.isEdit.uid,
        domainId: props.isEdit.domainId,
        location: props.isEdit.location,
        rruleText: props.isEdit.rrule !== "" ? editRRule.toText() : "",
        description: props.isEdit.description, allDay: false, selectMember:selectMember,
        sender:props.isEdit.sender,receiver:props.isEdit.receiver
      });
    }
  }, [props.isEdit]);

  const { Option } = Select;
  

  const disabledDate = (from: any, current: any,to:any) => {
    let date1 = new Date(from);
    let date2 = new Date(to);
    let ddate = date1.getTime() < date2.getTime()?(from.getDate()):(from.getDate());
    return new Date(from.setDate(ddate)) >= current;
  };
  const nameInputChange = (name: string, e: any) => {
    setEventInfo({ ...eventInfo, [name]: e.target.value });
  };
  const handleDateChange = (value: any,dateString:any) => {
    if(value){
    setEventInfo({ ...eventInfo, startDate: value, isStartEventDate:false });
    }
  };
  const handleEndDateChange = (value: any) => {
    if(value){
    setEventInfo({ ...eventInfo, endDate: value, isEndEventDate:false }); 
    }
  };
  // const handleTimeChange = (value: any) => {
  //   var day = new Date(value);
  //   setEventInfo({ ...eventInfo, time: day });
  // };

  const updateEvent = async () => {
    let formData: any = eventInfo;
    const date = new Date();
    const currentTime = moment().format('HH:mm');
    if(eventInfo.participants.length <1){
      setEventInfo({ ...eventInfo, assigneeError: true});
      
    } else if(Date.parse(moment(new Date(eventInfo.startDate)).format('MM/DD/YYYY'))
    >Date.parse(moment(new Date(eventInfo.endDate)).format('MM/DD/YYYY'))){

      setEventInfo({...eventInfo, endError:true});
    }  else if(Date.parse(moment(new Date(eventInfo.startDate)).format('MM/DD/YYYY'))
    ===Date.parse(moment(date).format('MM/DD/YYYY')) && (currentTime  >  eventInfo.time)){
      setEventInfo({ ...eventInfo, startTimeError: true});
 
    }  else {
    let key: any = {}
    if (window.location.pathname === '/contacts') {
      key = "contact"
    } else {
      key = "chat"
    }
    updateEventCreation(formData, key);
    cancelWindow();
  }
  };
  const handleChange = (value: any) => {
    let error = value.length <1 ? true:false;
    let contact: any =
      value.map((item: string) => {
        return getcontactDetail(item.toString());
      });
    setEventInfo({
      ...eventInfo, assigneeError: error, participants: value, isAddParticipant: false,
      selectMember: contact, contacts: evens
    });
    //setEventInfo({ ...eventInfo, participants: contact, isAddParticipant: false, contacts: contactList, selectMember:value });
  };


  const setStartTime = (val: any) => {
    // setcreateTask({...createTask, startTime:val.key,startTimeError:false});
    setEventInfo({ ...eventInfo, time: val.key});
  };
  const radioChecked = (e: any) => {
    setEventInfo({ ...eventInfo, calendarType: e.target.value });
  };
 
  const cancelWindow = () => {
    if (window.location.pathname === '/contacts'&& !chatWindow.isMySpace) {
      props.handleToggle();
    }
    !chatWindow.isMySpace ? chatSideWindow(true, "eventlist", {}) : chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    
  };

  const participantPopUP = (switchValue: boolean) => {
    setEventInfo({ ...eventInfo, isAddParticipant: switchValue });
  };

  // const BlurAssignee = (switchValue: boolean) => {
  //   setEventInfo({ ...eventInfo, isLocation: switchValue });
  // };
  
  const editStartDate = () => {

    setEventInfo({ ...eventInfo, isStartEventDate: !eventInfo.isStartEventDate});
  }
  
  const editEndDate = () => {

    setEventInfo({ ...eventInfo, isEndEventDate: !eventInfo.isEndEventDate });
  }
  const updateState = (data: any) => {
    var someDate = new Date(eventInfo.startDate);
    var result = data.byEnddate;
    if (data.recurrence === "Daily" && data.value_disabled === 2) {
      let datechange = someDate.setDate(someDate.getDate() + data.afteroccur);
      result =  new Date(datechange);
      
    } else if (data.recurrence === "Weekly" && data.value_disabled === 2) {
      let datechange = someDate.setDate(someDate.getDate() + (data.afteroccur * 7));
      result = new Date(datechange);
    } else if (data.recurrence === "Monthly" && data.value_disabled === 2) {
      let datechange = someDate.setDate(someDate.getDate() + (data.afteroccur * 30));
      result = new Date(datechange);
    } else {
      result = data.byEnddate;
    }
    if(data.recurrence !== "None"){
      eventInfo['endDate'] = result;
      let rule = RRuleGeneration(data, eventInfo);
      setEventInfo({
        ...eventInfo, endDate: result, rruleValue: rule.toString(),
        rruleText: rule.toText(), recurrence: data.recurrence
      });
    } else {
      setEventInfo({
        ...eventInfo, rruleText: "",recurrence: data.recurrence,rruleValue:""
      });
    }
    

  };
  const removeAssignee=(list:any)=>{
    let tempAttch:any = eventInfo?.selectMember;
    let temppAttch:any = eventInfo?.participants;
    const memIndex:any =_.findIndex(eventInfo?.participants,((data:any)=>{
      return data === list?.sip_login_id;
    }));
    if (memIndex > -1) {
      tempAttch.splice(memIndex, 1);
      temppAttch.splice(memIndex, 1);
    }
    setEventInfo({ ...eventInfo, selectMember: tempAttch,participants:temppAttch });
    
  };
  const searchInput = (e: string) => {
    let searchText = e.toLowerCase();
    let filterParticipant = SearchFilter(eventInfo.tempfilteredContacts, searchText);
    setEventInfo({ ...eventInfo, contacts: filterParticipant });
   
  };
  const changeRemainder = (val:any)=>{
    setEventInfo({ ...eventInfo, reminder: val.key });
  }
  const deleteEvent = ()=>{
    setdeleteEvent(true);
  }
  const EventDelete = ()=>{
    deleteEventCreation(eventInfo);
    setdeleteEvent(false);
    cancelWindow();
  }
  const closeDeleteModal = ()=>{
    setdeleteEvent(false);
  }
  let len = Math.ceil((eventInfo?.contacts?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  const menu = (
    <Menu onClick={changeRemainder}>
      <Menu.Item key={'No reminder'}>No reminder</Menu.Item>
      <Menu.Item  key={'1 minutes before'}>1 minutes before</Menu.Item>
      <Menu.Item  key={'5 minutes before'}>5 minutes before</Menu.Item>
      <Menu.Item  key={'10 minutes before'}>10 minutes before</Menu.Item>
      <Menu.Item  key={'30 minutes before'}>30 minutes before</Menu.Item>
      <Menu.Item  key={'1 hour before'}>1 hour before</Menu.Item>
    </Menu>
  );
 
    const allcontact = eventInfo.contacts.map((contact: any, index: number) => <Option value={contact?.sip_login_id}
    key={index}>
    <div className="dropdowndesign">
        <div className="usergroups">
          <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                                {contact?.ImageURL || contact?.profile_image_url ?
                                  <img src={contact?.ImageURL ? contact?.ImageURL : contact?.profile_image_url} alt="" /> :
                                  <span>{contact?.caller_id?.charAt(0).toUpperCase()}</span>}
                                <URStatusDot
                                  className={userStatusColor(contact?.user_status, 'small')} />
                              </>} />
        </div>
      <div className="names">{contact.caller_id}</div>
      <div className="ext">{contact.ext}</div>
    </div>
  </Option>);

  // const allremainder = reminderOptions.map((d: any) => <Option value={d.name}
  //   key={d.id}>{`${d.name}`}</Option>);



  let timeDurationList: any = Array.from(Array(24).keys());  
  const startTime = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={setStartTime}>
       { timeDurationList.map((value: string, index: number) => {
    return (
      <>{index === 0 ?
        <>
         <Menu.Item
            key={`${index}:00`}>{`00:00`}</Menu.Item>
          <Menu.Item 
            key={`${index}:30`}>{`00:30`}</Menu.Item>
        </>
        :
        <>
          <Menu.Item 
           key={`${value.toString().length === 1 ? '0'+value : value}:00`}>{`${value.toString().length === 1 ? '0'+value : value}:00`}</Menu.Item>
          <Menu.Item key={`${value.toString().length === 1 ? '0'+value : value}:30`}
            >{`${value.toString().length === 1 ? '0'+value : value}:30`}</Menu.Item>
           
        </>
      } 
      </>
      );
    })
  }
    </Menu>
  );
  const menues = (
    <Menu className="deleteviews" onClick={deleteEvent}>
      <Menu.Item>Delete</Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className={`${styles.neweventpopupscreen} ${"scrollerhover"} ${"rightbarforactions"}`}>
        <div className={styles.titletopsec}>
          <h2>{eventInfo.eventName} {isAssignee && <><Dropdown overlay={menues} placement="bottomRight">
          <span className="icon_overflow"></span></Dropdown></>}</h2>
          <p className={styles.descrio}>Description</p>
        {!isAssignee &&  <p >{eventInfo.description}</p> }
     
        {isAssignee && <TextArea value={eventInfo.description} placeholder="Add more details to this task…" onChange={(e: any) => nameInputChange('description', e)}></TextArea>}
        
        
          {!isAssignee &&   <><div className={styles.middlelayers}>
            <div className={styles.lefts}>Start Date</div>
            <div className={styles.rights}>
              <div className={styles.overall}>
                <img src={taskimg1} alt="" />
                {eventInfo.startDate ? moment(new Date(eventInfo.startDate)).format('DD MMM') :
                  "Start Date"}
                <span className="icon_close"></span>
              </div>
            </div>
          </div><div className={styles.middlelayers}>
              <div className={styles.lefts}>Time</div>
              <div className={styles.rights}>
                <div>
                  <div className={`${styles.timing} ${styles.overall}`}><img src={taskimg1} alt="" />
                    {eventInfo.time ? eventInfo.time : "Time"}
                  </div>

                </div>
              </div>
            </div></>
          
          }
          {isAssignee &&   <><div className={styles.middlelayers}>
            <div className={styles.lefts}>Start Date</div>
            <div className={styles.rights}>
              <div className={styles.overall} onClick={editStartDate}>
                <img src={taskimg1} alt="" />
                {eventInfo.startDate ? moment(new Date(eventInfo.startDate)).format('DD MMM') :
                  "Start Date"}
                <span className="icon_close"></span>
              </div>
              <div className={styles.actionnews}>

                {eventInfo.isStartEventDate && <DatePicker className={`customDatepicker ${styles.dates}`} format={'DD/MM/YYYY'}
                  value={moment(eventInfo.startDate)}
                  disabledDate={(e) => disabledDate(new Date(), e, eventInfo.startDate)}
                  dropdownClassName='datepickerDropdown' placeholder='Start Date' onChange={handleDateChange} />}
              </div>
            </div>
          </div><div className={styles.middlelayers}>
              <div className={styles.lefts}>Time</div>
              <div className={styles.rights}>
                <div>
                  <Dropdown overlay={startTime} placement="bottomRight" className={eventInfo.startTimeError ? "errorInput" : ''}>
                    <div className={`${styles.overall} ${styles.timing}`}>
                      <img src={taskimg1} alt="" />
                      {eventInfo.time ? eventInfo.time : "Time"}
                    </div></Dropdown>
                </div>
              </div>
            </div></>
          
          }
          {!isAssignee && <div className={styles.middlelayers}>
            <div className={styles.lefts}>Duration</div>
            <div className={styles.rights}>
            <div className={`${styles.timing} ${styles.overall}`}><img src={taskimg1} alt="" />
            { eventInfo.hours >0 && eventInfo.hours +"h"}
              </div>
            </div>
          </div> }

          {isAssignee &&  <div className={styles.middlelayers}>
            <div className={styles.lefts}>Duration</div>
            <div className={styles.rights}>
                <Dropdown overlay={startTime} placement="bottomRight" disabled={false}>
                <div className={styles.overall}>
                  <img src={taskimg1} alt="" />
                  { eventInfo.hours >0 && eventInfo.hours +"h"}
                  {/* {eventInfo.durationRes && eventInfo.minutes >0 && eventInfo.minutes +"M"} */}
                </div></Dropdown>
            </div>
          </div> }
          {!isAssignee &&  
             <div className={styles.middlelayers}>
             <div className={styles.lefts}>End Date</div>
             <div className={styles.rights}>
             <div className={eventInfo.endError?"errorInput":''}>
               <div className={styles.overall}>
                 
                 <img src={taskimg1} alt="" />
                 {eventInfo.endDate ? moment(new Date(eventInfo.endDate)).format('DD MMM') :
                 "Start Date"}
                 <span className="icon_close"></span>
               </div>
               </div>
             </div>
           </div>
    }
        {isAssignee && <div className={styles.middlelayers}>
            <div className={styles.lefts}>End Date</div>
            <div className={styles.rights}>
            <div className={eventInfo.endError?"errorInput":''}>
              <div className={styles.overall} onClick={editEndDate}>
                
                <img src={taskimg1} alt="" />
                {eventInfo.endDate ? moment(new Date(eventInfo.endDate)).format('DD MMM') :
                "Start Date"}
                <span className="icon_close"></span>
              </div>
              </div>

              {/* <div className={styles.actionnews}>
                {eventInfo.isEndEventDate &&  <DatePicker className={`customDatepicker ${styles.dates}`} format={'DD MMM'}
                value={moment(eventInfo.endDate)}
                open={true}
                dropdownClassName='datepickerDropdown' 
                disabledDate={(e) => disabledDate(new Date(), e)}
                placeholder='4 Sep' onChange={handleEndDateChange} />}
              </div> */}
              <div className={styles.actionnews}>
             { eventInfo.isEndEventDate &&  <DatePicker className="customDatepicker" format={'DD/MM/YYYY'}
                value={moment(eventInfo.endDate)}
                disabledDate={(e) => disabledDate(new Date(), e,eventInfo.endDate)}  
                  dropdownClassName='datepickerDropdown' placeholder='End Date' onChange={handleEndDateChange} />}
                    </div>
            </div>
          </div>}
          <div className={styles.selectopt}>
            <span>{eventInfo.rruleText}</span>
          </div>
          {isAssignee &&   <div className={styles.middlelayers}>
              <div className={styles.recurringcheckbox} style={{}}>
                <ClickDropdown recur={props.isEdit} updateState={updateState}></ClickDropdown>
              </div>
          </div> }

          {/* <div className={styles.middlelayers}>
            <div className={styles.lefts}>Location</div>
            <div className={styles.rights} >
            {!eventInfo.isLocation &&  <span  onClick={() => BlurAssignee(!eventInfo.isLocation)}> 
            {eventInfo.location ===""?"location":eventInfo.location }</span>}
              {eventInfo.isLocation && <Input value={eventInfo.location} className={styles.editInputGray}
              onChange={(e: any) => nameInputChange('location', e)}
            /> }
            </div>
          </div> */}
          <div className={styles.middlelayers}>
          <div className={styles.lefts}>Location</div>
              <div className={styles.rights}>
                 <Input value={eventInfo.location} className={styles.editInputGray}
              onChange={(e: any) => nameInputChange('location', e)}
            /> 
              </div>
        </div>

          {  <>
            <div className={styles.middlelayers}>
              <div className={styles.lefts}>Participants</div>
              <div className={`${styles.rights} ${styles.overrights}`}>
                {eventInfo.selectMember.map((list: any,index:any) =>
                (
                    <div className={styles.profiles} key={index}>
                      <div className={`${styles.usergroups}`}>
     
                        <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                                {list?.ImageURL || list?.profile_image_url ?
                                  <img src={list?.ImageURL ? list?.ImageURL : list?.profile_image_url} alt="" /> :
                                  <span>{list?.caller_id?.charAt(0).toUpperCase()}</span>}
                                <URStatusDot
                                  className={userStatusColor(list?.user_status, 'small')} />
                              </>} />
                      </div>
                      <div className={styles.names}>{list?.caller_id}</div>
                      <span className={`icon_close ${styles.closing}`} onClick={()=>removeAssignee(list)}></span>
                    </div>
                )
                )}
                <div className={styles.selectusers}>
                 {isAssignee && <div className={styles.addmem} onClick={() => participantPopUP(!eventInfo.isAddParticipant)} >
                    +
                  </div>}
                  {eventInfo.isAddParticipant &&  <div className={styles.insideicon}>
                  <img src={taskimg2} alt="" /><Select
                    mode="multiple"
                    onChange={handleChange}
                    onSearch={(e: string) => searchInput(e)}
                    style={{ width: '100%' }}
                    filterOption={false}
                    showSearch={true}
                    value={eventInfo.participants}
                    placeholder="No Assignee"
                    className="newselects taskcreations foreventing">
                    {allcontact}
                  </Select> </div>}
                  
                </div>
                {eventInfo?.assigneeError&& <p className={styles.errorMsgs}>Participants required</p>}
              </div>
             
            </div>

          </>
          }

          <div className={styles.middlelayers}>
            <div className={styles.lefts}>Reminder</div>
            <div className={styles.rights}>

            <Dropdown overlay={menu} placement="bottomCenter" ><h3>{eventInfo.reminder}
            <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
              {/* <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="No participants selected"
                className="selectfield"
                onChange={(e: any) => handleSelectChange('reminder', e)}
                optionFilterProp="children" value={eventInfo.reminder}>
                {allremainder}
              </Select> */}
            </div>
          </div>

          <div className={styles.selectopt}>
            <div className={`${styles.calenderText} ${styles.lefts}`}>Add to calendar</div>
            <div className={styles.rights}>
              <div className="radiobuttonsec">
                <Form.Item>
                  <Radio.Group onChange={(e) => radioChecked(e)} value={eventInfo.calendarType}>
                  <Radio value={'none'}><span className="radiotxt">
                    None</span></Radio>
                    <Radio value={'icloud'}><span className="radiotxt"><img src={IcloudImg} alt={IcloudImg} />
                      iCloud</span></Radio>
                    <Radio value={'google'}><span className="radiotxt"><img src={GoogleCalcImg} alt={GoogleCalcImg} />
                      Google Calendar</span></Radio>
                    <Radio value={'outlook'}><span className="radiotxt"><img src={OutlookImg} alt={OutlookImg} />
                      Outlook</span></Radio>
                  </Radio.Group>
                </Form.Item>

              </div>
            </div>
          </div>

          {isAssignee &&   <div className={styles.bottomlayers}>
            <URButton name="Cancel" className="urButton buttonWhite" onClick={cancelWindow} />
            {isAssignee && ( memberList.includes(userdetails?.sip_login_id) || chatWindow?.chatWindowDetails?.sip_login_id) ?<URButton name="Update" className="urButton buttonBlue marlftmin" onClick={updateEvent} htmlType="submit" />  : null}
          </div> }

        </div>
      </div>
      <Modal title="Delete Event?"
        centered
        visible={deleteevent}
        onOk={EventDelete}
        onCancel={closeDeleteModal}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
          Are you sure you want to permanently delete this event?
      </Modal>
    </>
  );
};
